import React from 'react';
import { Paper,Divider, Grid } from '@material-ui/core';
import { FilterComponent } from '../../../shared_elements';
import Skeleton from '@material-ui/lab/Skeleton';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'
import { leasesStatusGraphFilterOps } from '../';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
const LesseeGraph = ({ lesseeGraphData, lesseeOptions, skeletonLoader, filter, getResponseBack, callExternalFunction, lesseeOption }) => {
    let filterOptions = Object.assign({}, leasesStatusGraphFilterOps);
    const options = {
        chart: {
            type: 'column',
            zoomType: 'xy',
            panning: true,
            panKey: 'shift',
            styledMode: true,
            height: 700
        },
        title: {
            text: 'Based on Lessee',
            align: 'left',
            style: {
                fontFamily: 'Conv_IBMPlexSans-Regular',
                fontSize:'16px'
            }
        },
        subtitle: {
            text: `${lesseeGraphData.title ? lesseeGraphData.title : ''}`,
            align: 'left'
        },
        xAxis: {
            categories: lesseeGraphData && lesseeGraphData.lease_status_categories,
            labels: {
                formatter: function () {
                    return this.value.length>23 ? this.value.toString().substring(0, 20) + '...' : this.value.toString();
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Number of Leases'
            },
            gridLineDashStyle: 'longdash',
            stackLabels: {
                enabled: true,
                style: {
                    color: ( // theme
                        Highcharts.defaultOptions.title.style &&
                        Highcharts.defaultOptions.title.style.color
                    ) || 'black',
                    textOutline: 'none',
                    fontFamily: 'Conv_IBMPlexSans-SemiBold',
                    fontSize:'13px'
                }
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                pointWidth: 25,
                depth: 40,
                dataLabels: {
                    enabled: true
                },
                point: {
                    events: {
                      click: function() {
                        callExternalFunction(this.series.name, lesseeOptions.find(item => item.name == this.category), 'basedOnLessee');
                      }
                    }
                }
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> <br/>'
        },
        legend: {
            enabled: true
        },
        series: lesseeGraphData && lesseeGraphData.lease_status_lessee,
        credits: false,
        exporting: {
            buttons: {
                contextButton: {
                  menuItems: ['downloadPNG', 'downloadPDF'],
                }
            },
            filename: 'Lease(s)-Based on Lessee Chart',
        }
    }

    return (
        skeletonLoader ? <Skeleton variant="rect" height={700} width='100%' /> : 
        <Paper>
            <div style={{padding:'0 5px'}}>
                <FilterComponent 
                    filter={filter}
                    filterMenu={filterOptions}
                    getResponseBack={(applyFilter) => getResponseBack(applyFilter)}
                />
            </div>
            <Divider />
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                    containerProps={{ style: { height: "400px" } }}
                    allowChartUpdate
                />
            </div>
            
        </Paper>
    )
}
export default LesseeGraph
